import { Injectable, signal, effect } from "@angular/core"

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  isDarkMode = signal<boolean>(this.getInitialTheme())

  constructor() {
    effect(() => {
      if (this.isDarkMode()) {
        document.documentElement.classList.add("dark", "dark-theme")
      } else {
        document.documentElement.classList.remove("dark", "dark-theme")
      }
      localStorage.setItem("theme", this.isDarkMode() ? "dark" : "light")
    })
  }

  toggleTheme() {
    this.isDarkMode.update((dark) => !dark)
  }

  private getInitialTheme(): boolean {
    const savedTheme = localStorage.getItem("theme")
    if (savedTheme) {
      return savedTheme === "dark"
    }
    return window.matchMedia("(prefers-color-scheme: dark)").matches
  }
}
